<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Statuts et Reglements" />
            <StaTut />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import StaTut from '../Statut/Statut.vue'

export default {
    name: 'StatutPage',
    components: {
        NavBar,
        PageTitle,
        StaTut,
        FooterComp,
    }
}
</script>